import React, { Fragment, useState } from "react";
import { paginate } from "../../utils/paginate";
import BlogCard from "../Card/BlogCard";
import BlogCard2 from "../Card/BlogCard2";
import Card2 from "../Card/Card2";
import Pagination from "../Common/Pagination";
import SecTitle from "../Common/SecTitle";
import { useEffect } from "react";
import { getNews } from "../../services/NewsService";
import { getBlogs } from "../../services/BlogsService";

const BlogIndex = () => {
  const [perPage, setPerPage] = useState(9);
  const [currentPage, setCurrentPage] = useState(1);

  const [AllBlogs, setAllBlogs] = useState([]);
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [mostViewdBlogs, setMostViewedBlogs] = useState([]);

  const getBlogsList = async () => {
    try {
      const data = await getBlogs();
      console.log("dataINdex", data);
      setAllBlogs(data.data.Data);
      setRecentBlogs(data.data.latest_blogs);
      setMostViewedBlogs(data.data.most_popular);
    } catch (ex) {}
  };
  useEffect(() => {
    getBlogsList();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedBlogs = paginate(AllBlogs, currentPage, perPage);

  if (AllBlogs.length == 0) return null;
  if (recentBlogs.length == 0) return null;
  if (mostViewdBlogs.length == 0) return null;
  return (
    <Fragment>
      <section className="mt-5">
        <div className="container">
          <SecTitle title="پربازدیدترین بلاگ ها" />
          <div className="row align-items-center mx-0">
            <div className="col-lg-6">
              <Card2 data={mostViewdBlogs[0]} />
            </div>
            <div className="col-lg-6 g-3">
              <div className="row g-4">
                <div className="col-lg-6">
                  <Card2 data={mostViewdBlogs[1]} />
                </div>
                <div className="col-lg-6">
                  <Card2 data={mostViewdBlogs[2]} />
                </div>
                <div className="col-lg-6">
                  <Card2 data={mostViewdBlogs[3]} />
                </div>
                <div className="col-lg-6">
                  <Card2 data={mostViewdBlogs[4]} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="blur_bg">
        <SecTitle title="کل بلاگ ها" />
        <div className="row mx-0">
          <div className="col-lg-3">
            <div className="card ">
              <div className="card-body rounded-3 shadow-sm">
                <h5 className="card-title">جدیدترین بلاگ ها</h5>
                {recentBlogs && recentBlogs.length !== 0
                  ? recentBlogs.map((item) => (
                      <div key={item.id}>
                        <hr />
                        <BlogCard2 data={item} />
                      </div>
                    ))
                  : null}
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="row">
              {paginatedBlogs && paginatedBlogs.length !== 0 ? (
                paginatedBlogs.map((item) => (
                  <div
                    key={item.id}
                    className="col-lg-4 col-md-4 col-md-2 mb-3"
                  >
                    <BlogCard item={item} detailsUrl="NewsDetails" />
                  </div>
                ))
              ) : (
                <div className="text-center">داده ای جهت نمایش وجود ندارد</div>
              )}
            </div>
            <Pagination
              totlal={AllBlogs.length}
              currentPage={currentPage}
              perPage={perPage}
              onPageChange={handlePageChange}
            />
          </div>
          <div className="col-lg-1"></div>
        </div>
      </section>
    </Fragment>
  );
};

export default BlogIndex;
